<div class="transfers-selector-options">
  <ng-container *ngFor="let transfer of transfers">
    <div
      class="transfers-selector-options__transfer"
      [ngClass]="{
        'transfers-selector-options__transfer--selected': selectedTransferRow === transfer.row,
      }"
      (click)="setSelectedTransferRow(transfer.row)"
      (keydown)="handleKeySelection($event, transfer.row)"
      [attr.data-qa]="'transferSelectorOptions_transfer_' + transfer.row"
      tabindex="0"
      role="button"
      [attr.aria-pressed]="selectedTransferRow === transfer.row"
      [attr.aria-label]="'Select transfer: ' + transfer.transferStation"
    >
      <div class="transfers-selector-options__transfer__station">
        <i
          class="transfers-selector-options__transfer__station__icon"
          [ngClass]="'transfers-selector-options__transfer__station__icon--' + transfer.stationType?.toLowerCase()"
        ></i>
        <div class="transfers-selector-options__transfer__station__name">
          {{ transfer.transferStation }}
        </div>
      </div>

      <div class="transfers-selector-options__transfer__price">
        {{ transfer.multiCurrencyPrice | lxPrice : { currency: currency$ | async } }}
      </div>
    </div>
  </ng-container>
  <div
    class="transfers-selector-options__transfer"
    [ngClass]="{
      'transfers-selector-options__transfer--selected': !selectedTransferRow
    }"
    (click)="removeSelectedTransferRow()"
    (keydown)="handleKeyDeselection($event)"
    data-qa="transferSelectorOptions_transfer_noTransfer"
    tabindex="0"
    role="button"
    [attr.aria-pressed]="!selectedTransferRow"
    aria-label="Select no transfer option"
  >
    <div class="transfers-selector-options__transfer__station">
      <div class="transfers-selector-options__transfer__station__name" i18n>No transfer</div>
    </div>
  </div>
</div>
